import {Checkbox} from "@mui/material";
import {observer} from "mobx-react";
import * as React from "react";

function PermissionCheckbox({permission, form, fieldName}) {
    const assignedPermissions = form.getFieldValue(fieldName)
    const isAssigned = assignedPermissions.includes(permission)

    const assignOrRevokePermission = async (event) => {
        const editedPermissions = event.target.checked
            ? [...assignedPermissions, permission]
            : assignedPermissions.filter(assignedPermission => assignedPermission !== permission)
        await form.updateFieldWithValue(fieldName, editedPermissions)
    }

    return <Checkbox size="small" checked={isAssigned} onChange={assignOrRevokePermission}/>
}

export default observer(PermissionCheckbox);
